import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=d43dcd4e&scoped=true&"
import script from "./Triage.vue?vue&type=script&lang=js&"
export * from "./Triage.vue?vue&type=script&lang=js&"
import style0 from "./Triage.vue?vue&type=style&index=0&id=d43dcd4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43dcd4e",
  null
  
)

export default component.exports